import { useState, useEffect, useContext, useMemo, useRef } from "react";
import styles from './index.module.scss'
import Iconfont from '@utils/Iconfont';
import { Divider, message, Button } from 'antd';
import { IMAGE_TYPE, RESOURCE_TYPE } from '@utils/CONST'
import { workflowOfSendTask, doHDPreview } from '@utils/workflowOfBuildTaskV2';
import { workflowOfLoadTaskInfo, workflowOfReGenerate } from '@utils/workflowOfBuildTaskV2';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '@utils/AppContext';
import API from '@api/api'
import Utils from '@utils/utils'


const PicModalFooter = (props) => {
    const { item, currentViewIsHD, setCurrentViewIsHD, setHDPreviewLoadingFlag } = props
    const { setGlobalTaskReadFlag } = useContext(AppContext)
    const navigate = useNavigate()
    const [imageUrl, setImageUrl] = useState()
    useEffect(() => {
        const fetchImageUrl = async () => {
            try {
                let res = await API.commonDownload({ taskId: item.taskId });
                if (res?.code != 0) throw new Error(res?.message);
                const image = res.data;
                setImageUrl(image)
            } catch (error) {
                console.error('Failed to fetch image:', error);
            }
        }

        if (item) {
            fetchImageUrl();
        }
    }, [item]);

    const handleClick = async (jumpTotype, targetType = "inputImage") => {
        let noWaterRes = await API.commonDownload({ taskId: item?.taskId })
        if (noWaterRes?.code != 0) throw new Error(noWaterRes?.message)
        const image = noWaterRes.data
        const res = await workflowOfSendTask(jumpTotype, image, targetType)
        if (!res) return
        const { pathname, options } = res
        navigate(pathname, options)
    }


    const HDClick = () => {
        if (currentViewIsHD) {
            setCurrentViewIsHD(false)
        } else {
            if (item?.results?.[0]?.hdImage) {
                setCurrentViewIsHD(true)
            } else {
                doHDPreview(item.taskId, item.imageType, () => {
                    props.fetchProjectDetail()
                })
            }
        }
    }

    const [rebuildLoading, setRebuildLoading] = useState(false)
    const rebuildClick = async () => {
        const succeededItem = item
        if (succeededItem) {
            try {
                setRebuildLoading(true)
                const res = await workflowOfLoadTaskInfo(succeededItem.imageType, succeededItem.taskId)
                if (!res) return
                const { pathname, options } = res
                navigate(pathname, options)
            } catch (err) {
                message.warning(err.message)
            } finally {
                setRebuildLoading(false)
            }
        } else {
            message.warning('请先等待生成成功后再重新编辑')
        }
    }

    const [recreateLoading, setRecreateLoading] = useState(false)
    const createAgain = async () => {
        const succeededItem = item
        if (succeededItem) {
            try {
                setRecreateLoading(true)
                const taskID = succeededItem.taskId
                const res = await workflowOfReGenerate(succeededItem.imageType, taskID)
                if (!res) return
                const { disabled, pathname, options } = res
                if (disabled) {
                    message.warning("版本更新，请重新编辑后再重新生成")
                    navigate(pathname, options)
                } else {
                    message.success('生成中，请稍后！')
                    setGlobalTaskReadFlag(prev => !prev)
                    props.fetchProjectDetail()
                }
            } catch (err) {
                message.warning(err.message)
            } finally {
                setRecreateLoading(false)
            }
        } else {
            message.warning('请先等待生成成功后再重新生成')
        }
    }

    const extractionClick = () => {
        window.open(imageUrl ? `/home/image_extraction?url=${encodeURIComponent(imageUrl)}` : `/home/image_extraction`, '_blank')
    }

    const resizeClick = () => {
        window.open(imageUrl ? `/home/imageResize?url=${encodeURIComponent(imageUrl)}` : `/home/imageResize`, '_blank')
    }

    const IsEiEdit = useMemo(() => {
        return item.imageType == IMAGE_TYPE.AI_IMAGE_EXTRACTION ||
            item.imageType == IMAGE_TYPE.REMOVE_INPAINT ||
            item.imageType == IMAGE_TYPE.AI_BEAUTY ||
            item.imageType == IMAGE_TYPE.AI_SMART_BEAUTY ||
            item.imageType == IMAGE_TYPE.IMAGE_RESIZE ||
            item.imageType == IMAGE_TYPE.HAND_FIX
    }, [item])


    const popoverContent = () => (
        <div className={styles.popover_content}>
            {
                (item.imageType != IMAGE_TYPE.COMMODITY && item.imageType != IMAGE_TYPE.COMMODITYRECOLOR) &&
                <span
                    className={styles.footer_text}
                    onClick={() => navigate("/home/aiEdit", { state: { menuKey: 'handRepair', picUrl: imageUrl } })}>
                    <Iconfont type="icon-handRepairOutlined" className={styles.Icon} />手部修复</span>
            }

            <span
                className={styles.footer_text}
                onClick={() => navigate("/home/aiEdit", { state: { menuKey: 'magicErase', picUrl: imageUrl } })}>
                <Iconfont type="icon-magicRemoveOutlined" className={styles.Icon} />魔法擦除</span>
            <span className={styles.footer_text} onClick={extractionClick}><Iconfont type="icon-mattingOutlined" className={styles.Icon} />智能抠图</span>
            <span className={styles.footer_text} onClick={resizeClick}><Iconfont type="icon-picResizeOutlined" className={styles.Icon} />高清改尺寸</span>
        </div>
    )

    const downloadClick = async (taskId) => {
        const res = await API.batchCommonDownload({ taskId })
        if (res?.code != 0) throw new Error(res?.message)
        Utils.downUrl(res.data)
    }

    return (
        <div className={styles.PicModalFooter}>
            {
                (IsEiEdit || item?.orgData) ? <span></span> : <div className={styles.footer}>
                    {/* {
                        item.imageType != IMAGE_TYPE.MODEL_VIDEO && <>
                            {showBtnList}
                            <Popover placement="bottom" content={popoverContent}>
                                <span className={styles.footer_text}><MoreOutlined /> 更多功能</span>
                            </Popover>
                            <Divider type="vertical" />
                        </>
                    } */}
                    {
                        !props.isSelectPage && <>
                            <span className={styles.footer_text} onClick={() => props.reEditClick(item?.projectId, item?.skuId, item?.taskId)}><Iconfont type="icon-rebuildOutlined" className={styles.Icon} />重新编辑</span>
                            <span className={styles.footer_text} onClick={() => { props.regenerateByTaskId(item?.taskId); props.onCancel() }}><Iconfont type="icon-generateOutlined" className={styles.Icon} />再次生成</span>
                            {/* <span className={styles.footer_text} onClick={HDClick}>
                                <Iconfont type={currentViewIsHD ? 'icon-closeHDOutlined' : 'icon-HDOutlined'} className={styles.Icon} />
                                {currentViewIsHD ? '关闭高清' : '高清预览'}
                            </span> */}
                        </>
                    }
                </div>
            }
            <Button className={styles.downloadBtn} style={{ margin: '0 12px' }} onClick={() => downloadClick(item?.taskId)}>下载图片</Button>
            {
                !props.isSelectPage && <>
                    <Button className={styles.downloadBtn} type={item.picked ? 'primary' : 'default'} onClick={(e) => props.handleChoose(e, item)}>
                        <Iconfont className={styles.Icon} type="icon-imgOutlined" />
                        {item.picked ? '已选中' : '选这张'}</Button>
                </>
            }
        </div>
    )
}

export default PicModalFooter